<template>
    <div>
        <h1 class="title is-3">Edit Project</h1>

<!--        <div v-if="project && project.id && project.assigned_to == null && project.senior_pm_id == null" class="notification is-danger">-->
<!--            Please assign a project manager.-->
<!--        </div>-->

<!--        <div v-if="project && project.id && !project.completion_date" class="notification is-danger">-->
<!--            Please set the estimated completion date.-->
<!--        </div>-->

        <o-tabs v-if="copy" type="is-boxed">
            <o-tab-item label="Property Info">
                <form class="is-clearfix" style="padding-bottom: 145px;">
                    <div class="columns">
                        <div class="column">
                            <o-field label="Name">
                                <o-input v-model="copy.name" />
                            </o-field>

                            <div class="field">
                                <o-checkbox v-model="copy.notable">Notable</o-checkbox>
                            </div>

                            <div class="between-center">
                                <o-field label="Customer" style="flex: 1">
                                    <o-select placeholder="Select a Company" v-model="copy.company_id" expanded>
                                        <option :value="null">Not Specified</option>
                                        <option
                                                v-for="company in companies"
                                                :value="company.id"
                                                :key="company.id">
                                            {{ company.name }}
                                        </option>
                                    </o-select>
                                </o-field>

                                <div class="field" style="margin: 20px 0 0 10px">
                                    <button @click.prevent="isCompanyModalActive = true" style="width: 170px" class="button is-primary">Add Company</button>
                                </div>
                            </div>

                            <div class="between-center">
                                <o-field label="Contact" style="flex: 1">
                                    <o-select placeholder="Select a Contact" v-model="copy.contact_id" expanded>
                                        <option :value="null">Not Specified</option>
                                        <option
                                                v-for="contact in contactsByCompanyId(copy.company_id)"
                                                :value="contact.id"
                                                :key="contact.id">
                                            {{ contact.full_name }}
                                        </option>
                                    </o-select>
                                </o-field>
                                <div class="field" style="margin: 20px 0 0 10px">
                                    <button @click.prevent="isCompanyContactModalActive = true" :disabled="!copy.company_id" style="width: 170px" class="button is-primary">Add Contact</button>
                                </div>
                            </div>

                            <div class="between-center">
                                <o-field label="Project Manager" :type="fieldType('assigned_to')" :variant="isValidProjectmanager? 'info': 'danger' " :message="getError('assigned_to')" style="flex: 1">
                                    <o-select placeholder="Select a Project Manager" v-model="copy.assigned_to" expanded>
                                        <option :value="null">Not Specified</option>
                                        <option v-for="user in activeUsers"
                                                :value="user.id"
                                                :key="user.id">
                                            {{ user.full_name }}
                                        </option>
                                    </o-select>
                                </o-field>
                                <div class="field" style="margin: 20px 0 0 10px">
                                    <button @click.prevent="notifyClient" :disabled="!canNotifyClient" style="width: 170px" class="button is-primary">
                                        Notify Client
                                    </button>
                                </div>
                            </div>

                            <o-field label="Street">
                                <o-input v-model="copy.street" />
                            </o-field>

                            <o-field label="Building">
                                <o-input v-model="copy.building"></o-input>
                            </o-field>

                            <o-field label="Borough">
                                <o-select placeholder="Select a borough" v-model="copy.borough" expanded>
                                    <option :value="null">Not Specified</option>
                                    <option
                                            v-for="borough in boroughs"
                                            :value="borough.id"
                                            :key="borough.id">
                                        {{ borough.name }}
                                    </option>
                                </o-select>
                            </o-field>

                            <o-field label="Block">
                                <o-input v-model="copy.block"></o-input>
                            </o-field>

                            <o-field label="Lot">
                                <o-input v-model="copy.lot"></o-input>
                            </o-field>

                            <o-field label="Start Date">
                                <datepicker placeholder="Select date" v-model="copy.start_date"/>
                            </o-field>

                            <o-field label="Est. Completion Date" :variant="isValidCompletionDate? 'info': 'danger'" :type="fieldType('completion_date')">
                                <datepicker placeholder="Select Date" v-model="copy.completion_date" :error="getError('completion_date')" />
                            </o-field>

                            <o-field label="Floor Number">
                                <o-input v-model="copy.floor_number"></o-input>
                            </o-field>
                        </div>

                        <div class="column">

                            <o-field label="Senior PM" :type="fieldType('senior_pm_id')" :message="getError('senior_pm_id')">
                                <autocomplete-select type="user" field-name="full_name" v-model="copy.senior_pm_id" :value="userById(copy.senior_pm_id)"/>
                            </o-field>

                            <o-field label="Status">
                                <o-select placeholder="Select a status" v-model="copy.status" expanded>
                                    <option :value="null">Not Specified</option>
                                    <option
                                            v-for="status in projectStatuses"
                                            :value="status.id"
                                            :key="status.id"
                                    >
                                        {{ status.name }}
                                    </option>
                                </o-select>
                            </o-field>

                            <o-field label="Type of Project" :type="fieldType('project_type')" :message="getError('project_type')">
                                <o-select placeholder="Select a Type of Project" expanded v-model="copy.project_type">
                                    <option
                                            v-for="projectType in projectTypes"
                                            :value="projectType.id"
                                            :key="projectType.id"
                                    >
                                        {{ projectType.name }}
                                    </option>
                                </o-select>
                            </o-field>

                            <o-field label="Zoning District">
                                <o-input v-model="copy.zoning_district"></o-input>
                            </o-field>

                            <o-field label="Overlay(s)">
                                <o-input v-model="copy.overlays"></o-input>
                            </o-field>

                            <o-field label="Map">
                                <o-input v-model="copy.map"></o-input>
                            </o-field>

                            <o-field label="Community Board">
                                <o-input v-model="copy.community_board"></o-input>
                            </o-field>

                            <o-field label="Bin">
                                <o-input v-model="copy.bin"></o-input>
                            </o-field>

                            <o-field label="Special District(s)">
                                <o-input v-model="copy.special_district"></o-input>
                            </o-field>

                            <o-field label="Job Comments">
                                <o-input maxlength="200" v-model="copy.job_comments" type="textarea"></o-input>
                            </o-field>

                        </div>
                    </div>

                    <div class="field is-grouped is-pulled-right">
                        <p class="control">
                            <router-link :to="{name: 'projects.index'}" class="button" >Cancel</router-link>
                        </p>
                        <p class="control">
                            <router-link :to="{name: 'projects.show', slug: item.id}" class="button" >Back to Project</router-link>
                        </p>
                        <p class="control">
                            <button @click.prevent="handleRemove" class="button is-danger">Delete</button>
                        </p>
                        <p class="control">
                            <button @click.prevent="handleCreateOrUpdate" v-submit="submitting" class="button is-success">Save</button>
                        </p>
                    </div>
                </form>
            </o-tab-item>

            <o-tab-item label="Owner Info">
                <form class="is-clearfix">
                    <div class="columns">
                        <div class="column">
                            <div class="between-center">
                                <o-field label="Property Owner" style="flex: 1">
                                    <o-select placeholder="Select a Property Owner" v-model="copy.owner_id" expanded>
                                        <option :value="null">Not Specified</option>
                                        <option
                                                v-for="company in companies"
                                                :value="company.id"
                                                :key="company.id">
                                            {{ company.name }}
                                        </option>
                                    </o-select>
                                </o-field>
                                <div class="field" style="margin: 20px 0 0 10px">
                                    <button @click.prevent="isCompanyModalActive = true" style="width: 170px" class="button is-primary">Add Company</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <div class="between-center">
                                <o-field label="Primary Contact" style="flex: 1">
                                    <o-select placeholder="Select a Primary Contact" v-model="copy.primary_contact_id" expanded>
                                        <option :value="null">Not Specified</option>
                                        <option
                                                v-for="contact in contacts"
                                                :value="contact.id"
                                                :key="contact.id">
                                            {{ contact.full_name }}
                                        </option>
                                    </o-select>
                                </o-field>
                                <div class="field" style="margin: 20px 0 0 10px">
                                    <button @click.prevent="isOwnerContactModalActive = true" :disabled="!copy.owner_id" style="width: 170px" class="button is-primary">Add Contact</button>
                                </div>
                            </div>
                        </div>
                        <div class="column">
                            <div class="between-center">
                                <o-field label="Secondary Contact" style="flex: 1">
                                    <o-select placeholder="Select a Secondary Contact" v-model="copy.secondary_contact_id" expanded>
                                        <option :value="null">Not Specified</option>
                                        <option
                                                v-for="contact in contacts"
                                                :value="contact.id"
                                                :key="contact.id">
                                            {{ contact.full_name }}
                                        </option>
                                    </o-select>
                                </o-field>
                                <div class="field" style="margin: 20px 0 0 10px">
                                    <button @click.prevent="isOwnerContactModalActive = true" :disabled="!copy.owner_id" style="width: 170px" class="button is-primary">Add Contact</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field is-grouped is-pulled-right">
                        <p class="control">
                            <router-link :to="{name: 'projects.index'}" class="button" >Cancel</router-link>
                        </p>
                        <p class="control">
                            <router-link :to="{name: 'projects.show', slug: item.id}" class="button" >Back to Project</router-link>
                        </p>
                        <p class="control">
                            <button @click.prevent="handleRemove" class="button is-danger">Delete</button>
                        </p>
                        <p class="control">
                            <button @click.prevent="handleCreateOrUpdate" v-submit="submitting" class="button is-success">Save</button>
                        </p>
                    </div>
                </form>
            </o-tab-item>
        </o-tabs >

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isCompanyModalActive" has-modal-card>
            <company-modal />
        </o-modal>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isCompanyContactModalActive" has-modal-card>
            <contact-modal
                    :quick-add="true"
                    :item="{company_id: copy.company_id}"
                    :project-id="projectId"
            />
        </o-modal>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isOwnerContactModalActive" has-modal-card>
            <contact-modal
                    :quick-add="true"
                    :item="{company_id: copy.owner_id}"
                    :project-id="projectId"
            />
        </o-modal>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import Datepicker from './../../components/Datepicker'
    import CompanyModal from './../../components/modals/Company'
    import ContactModal from './../../components/modals/Contact'
    import HandlesForm from './../../mixins/HandlesForm'
    import {userById} from "../../store/getters/users";

    export default {
        mixins: [HandlesForm],

        components: {
            Datepicker,
            CompanyModal,
            ContactModal,
        },

        mounted () {
            this.fetchProjectById(this.projectId)
                .then(res => {
                    this.copy = _.clone(res.data.data)
                    return res
                })
        },

        computed: {
            ...mapGetters(['projectById', 'contacts', 'boroughs', 'companies', 'users', 'userById', 'projectStatuses', 'contactsByCompanyId', 'projectTypes']),

            activeUsers() {
                return _.filter(this.users, user => ! user.blocked)
            },

            projectId() {
                return parseInt(this.$route.params.slug)
            },

            project() {
                return this.projectById(this.projectId)
            },

            canNotifyClient() {
                let p = this.project
                return p && (p.assigned_to || p.senior_pm_id)
            },

            isValidProjectmanager() {
              return !(this.project && this.project.id && this.project.assigned_to == null && this.project.senior_pm_id == null);
            },

            isValidCompletionDate(){
              return !(this.project && this.project.id && this.project.completion_date == null);
            }
        },

        data() {
            return {
                isCompanyModalActive: false,
                isCompanyContactModalActive: false,
                isOwnerContactModalActive: false,
            }
        },

        methods: {
          userById,
            ...mapActions(['fetchProjectById', 'createOrUpdateProject', 'removeProject', 'openMessageModal']),

            handleCreateOrUpdate() {
                let p = this.project
                let submit = this.wrapSubmit(this.createOrUpdateProject),
                    // pm or senior pm is a required field so one of these will be filled
                    pmAssigned = p && p.senior_pm_id == null && p.assigned_to == null

                submit(this.copy)
                    .then(res => {
                        if (pmAssigned) {
                            this.notifyClient(false)
                        }

                        this.successMessage('Project was successfull updated')
                        return res
                    })
            },

            notifyClient(closable = true) {
                this.openMessageModal({
                    entity: this.project,
                    entity_type: 'project',
                    context: 'project-pm-assigned-message',
                    closable
                })
            },

            handleRemove() {
                this.confirmMessage(
                    'Deleting project',
                    'Are you sure you want to <strong>delete</strong> this project? This action cannot be undone.',
                    'Delete Project'
                ).then(() => {
                    this.removeProject(this.copy)
                        .then(res => {
                            this.successMessage('Project deleted!')
                            this.$router.push(`/projects`)

                            return res
                        })
                })
            }
        }
    }
</script>
